import {ToolOpinion} from "@/entities/ToolOpinion";
import {RootStoreState} from "@/store/RootStoreState";
import {Module} from "vuex";
import {HttpHandler} from "@/http/HttpHandler";
import store from "@/store/index";

interface ToolState {
    tools: ToolOpinion[]
}

const toolModule: Module<ToolState, RootStoreState> = {
    namespaced: true,
    state: {
        tools: [],
    },
    getters: {
        getAllTools: state => {
            return state.tools;
        },
        getToolById: state => (id: number) => {
            return state.tools.find(x => x.id === id);
        },
    },
    mutations: {
        updateTools(state, tools) {
            state.tools = tools;
        }
    },
    actions: {
        async getToolsByBranchId({commit}, {branchId}) {
            let httpHandler = new HttpHandler(store);
            const tools = await httpHandler.getToolsByBranchId(branchId);
            commit('updateTools', tools);
        },
    },
};

export default toolModule;
